<template>
  <view class="radio-demo">
    <view-desc>正常选项: {{ radioValue }}</view-desc>
    <view class="cube-radio-demos">
      <cube-radio  option="{{ radio1 }}" wx:model="{{ radioValue }}" wx:model-prop="value">Option1</cube-radio>
      <cube-radio  option="{{ radio2 }}" wx:model="{{ radioValue }}" wx:model-prop="value">Option2</cube-radio>
    </view>
  </view>
</template>

<script>
import { createComponent } from '@mpxjs/core'

createComponent({
  options: {
    styleIsolation: 'shared'
  },
  data: {
    radio1: {
      value: 'Option1'
    },
    radio2: {
      value: 'Option2'
    },
    radioValue: ''
  }
})
</script>

<style lang="stylus">
// .radio-demo
//   .cube-radio-demo-style
//     padding 5px 10px
//     box-sizing border-box
//     background-color #fff
//   .desc
//     margin-top 15px
</style>

<script type="application/json">
  {
    "styleIsolation": "shared",
    "component": true,
    "usingComponents": {
      "view-desc": "../../components/desc/index",
      "cube-radio": "@mpxjs/mpx-cube-ui/src/components/radio/index"
    }
  }
</script>
